import { memo } from "react";
import styled from "styled-components";

const StyledTableFooter = styled.tfoot`
  background-color: #b9b5b5ff; /* Footer background */
  color: #2d2d2d; /* Footer text color */
  font-family: "Trebuchet MS", "Lucida Sans", Arial;
  font-weight: 600;
  border-top: 1px solid #e2e8f0;

  ${({ sticky }) =>
    sticky === "Yes" &&
    `
    position: sticky;
    bottom: 0;
    z-index: 5;
    box-shadow: 0 -1px 4px rgba(0,0,0,0.06);
  `}

  /* Make sure each td inherits footer styles */
  td {
    padding: ${({ compact }) => (compact === "Yes" ? "10px 14px" : "16px 18px")};
    background-color: #b9b5b5 !important; /* Important to override row/td styles */
    color: #2d2d2d !important;

    &:first-child {
      border-bottom-left-radius: 8px;
    }
    &:last-child {
      border-bottom-right-radius: 8px;
    }
  }

  tr {
    background-color: inherit; /* Ensure tr takes footer bg */
  }
`;

export default StyledTableFooter;
